/**
 * Login-screen SVG glyphs, ported verbatim from Ryan's app-shell.html prototype
 * (logomark lines 19519-19523, Microsoft Entra grid line 19549). SCRUM-295.
 * Both use `currentColor` / brand tokens so they inherit theme + brand color.
 */

/** BankIQ logomark — three stacked rounded squares at descending opacity. */
export function BankIqLogomark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="20 20 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="51.875"
        y="24"
        width="26.125"
        height="26.125"
        rx="3"
        fill="var(--cyan)"
        fillOpacity="0.3"
      />
      <rect
        x="24"
        y="51.875"
        width="26.125"
        height="26.125"
        rx="3"
        fill="var(--cyan)"
        fillOpacity="0.9"
      />
      <rect
        x="37.47"
        y="37.937"
        width="26.125"
        height="26.125"
        rx="3"
        fill="var(--cyan)"
        fillOpacity="0.6"
      />
    </svg>
  );
}

/**
 * Microsoft Entra icon — a 4-square stroked grid (NOT the official 4-color
 * Microsoft logo; matches the prototype's single-color grid glyph).
 */
export function MicrosoftEntraIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 18"
      width="14"
      height="14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="6.5" height="6.5" />
      <rect x="9.5" y="2" width="6.5" height="6.5" />
      <rect x="2" y="9.5" width="6.5" height="6.5" />
      <rect x="9.5" y="9.5" width="6.5" height="6.5" />
    </svg>
  );
}
